import { createSelector } from 'utils/app.util';

export const getAssetTestFromState = createSelector(
  (state) => state.getIn(['projects', 'assetTests', 'data']),
  (assets) => assets,
);
